export const GALLERY = "gallery";
export const UPLOAD = "upload";
